import { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { FaChevronDown } from "react-icons/fa";
import { useAuth } from '../Context/AuthContext';
import { useMasterDataContext } from '../Context/masterDataContext';


const Dashboard = ({ children }) => {
  const { user } = useAuth();
  const { sideBarData, loadSideBars } = useMasterDataContext();
  const [input,setInput]=useState("");
  // console.log(user, 'user')

  const [isOpen, setIsOpen] = useState(true);
  const [expandedNode, setExpandedNode] = useState(null);
  const [expandedChildNode, setExpandedChildNode] = useState(null);
  const [filteredMenu, setFilteredMenu] = useState([]);
  const [searchMenu,setSearchMenu]=useState([]);
  const toggleNode = (nodeId) => {
    setExpandedNode(prev => prev === nodeId ? null : nodeId);
  };

  const toggleChildNode = (childId) => {
    setExpandedChildNode(prev => prev === childId ? null : childId);
  };
  const filterMenu = () => {
    if (!sideBarData?.length || !user?.roles) return [];
    return sideBarData
      .filter(parent =>
        parent?.roleNames?.some(role =>
          user.roles.some(ur => ur.toLowerCase() === role.toLowerCase())
        )
      )
      .map(parent => {
        const filteredChildren = parent?.childNodes
          ?.map(child => {
            const filteredGrandChildren = child?.grandChildNodes
              ?.filter(gc =>
                gc?.roleNames?.some(role =>
                  user.roles.some(ur => ur.toLowerCase() === role.toLowerCase())
                )
              ) || [];

            if (
              child?.roleNames?.some(role =>
                user.roles.some(ur => ur.toLowerCase() === role.toLowerCase())
              ) &&
              (child.nodeUrl || filteredGrandChildren.length > 0)
            ) {
              return { ...child, grandChildNodes: filteredGrandChildren };
            }
            return null;
          })
          .filter(Boolean);

        return { ...parent, childNodes: filteredChildren };
      })
      .filter(parent => parent.childNodes?.length > 0);
  };

  useEffect(() => {
    console.log("i am run");
    loadSideBars();
  }, []);
  // const filterSearchMenu=()=>{
    
    
  //   const filter=filteredMenu.filter((f)=>f.nodeName.toLowerCase().includes(input.toLowerCase()));
  //   setFilteredMenu(filter)
  // }
  // Update filtered menu whenever sideBarData or user.roles change
useEffect(() => {
  const timer = setTimeout(() => {
    const menu = filterMenu(); // get the full, source menu

    const q = (input || "").trim().toLowerCase();

    // If no query, reset to full menu
    if (!q) {
      setFilteredMenu(menu);
      setSearchMenu(menu);
      return;
    }

    // 1) match by nodeName
    let filter = menu.filter(
      (f) => f?.nodeName?.toLowerCase().includes(q)
    );

    // 2) if none, try matching by child node names
    if (filter.length === 0) {
      filter = menu.filter(
        (f) =>
          Array.isArray(f?.childNodes) &&
          f.childNodes.some((c) => c?.nodeName?.toLowerCase().includes(q))
      );
    }

    setFilteredMenu(filter);
    setSearchMenu(menu);
  }, 300);

  return () => clearTimeout(timer);
}, [sideBarData, user?.roles, input]);

  // useEffect(()=>{
  //   filterSearchMenu();

  // },[input])
  const GrandChildItem = ({ to, children }) => (
    <li className="sub-item-heading">
      <NavLink to={to} onClick={(e) => e.stopPropagation()} className={({isActive}) => isActive ? "active" : ""}>
        {children}
      </NavLink>
    </li>
  );

  return (
    <div id="sidebar" className="sidebar">
      <div className="search-container" style={{marginTop:"10px",marginLeft:"10px"}}>
       <span style={{fontSize:"15px"}}>Search Node: </span>
       <br></br><input type="text" style={{minWidth:"50px", minHeight:"20px"}} onChange={(e)=>setInput(e.target.value)} ></input>
       </div>
      <div>
       
        <ul>
          {/* <li className="dropdown-heading-list">
            <NavLink to="/home" className="dropdown-heading-link">Dashboard</NavLink>
          </li> */}
          
          {filteredMenu.map(parent => (
            <div key={parent.nodeId}>
              <li onClick={() => toggleNode(parent.nodeId)} className="dropdown-heading-list">
                <p className="heading-txt">{parent.nodeName}</p>
                <FaChevronDown className={`dropdown-icon ${expandedNode === parent.nodeId ? "rotate" : ""}`} />
              </li>

              {expandedNode === parent.nodeId &&
                parent.childNodes.map(child => (
                  <div key={child.nodeId}>
                    <li className="sub-item-heading dropdown-sub" onClick={() =>
                      child.grandChildNodes?.length > 0 ? toggleChildNode(child.nodeId) : null
                    }>
                      {child.nodeUrl ? (
                        <NavLink to={child.nodeUrl} onClick={(e) => e.stopPropagation()} className={({isActive}) => isActive ? "active" : ""}>
                          {child.nodeName}
                        </NavLink>
                      ) : (
                        <span>{child.nodeName}</span>
                      )}
                      {child.grandChildNodes?.length > 0 && (
                        <FaChevronDown className={`dropdown-icon-small ${expandedChildNode === child.nodeId ? "rotate" : ""}`} />
                      )}
                    </li>

                    {expandedChildNode === child.nodeId &&
                      child.grandChildNodes.map(grand => (
                        <GrandChildItem key={grand.nodeId} to={grand.nodeUrl}>{grand.nodeName}</GrandChildItem>
                      ))
                    }
                  </div>
                ))
              }
            </div>
          ))}
        </ul>
      </div>

      <div className={`main-content ${isOpen ? "shrink" : "expand"}`}>
        {children}
      </div>
    </div>
  );
};

export default Dashboard;